
import { i18n } from "@/i18n";
import {
  BButton,
  BCol,
  BCollapse,
  BIcon,
  BIconPlus,
  BRow,
  BTable,
  BvTableFieldArray,
} from "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import IconEdit from "../common/icon/IconEdit.vue";
import IconTrash from "../common/icon/IconTrash.vue";
import AddUserOnFlowApproveModal from "./AddUserOnFlowApproveModal.vue";
import { IUserServicepointApproval } from "@/entities/servicepoint_approval";

@Component({
  name: "users-on-flow-approve",
  components: {
    BRow,
    BCol,
    BButton,
    BIcon,
    BIconPlus,
    BTable,
    BCollapse,
    IconEdit,
    IconTrash,
    AddUserOnFlowApproveModal,
  },
})
export default class UsersOnFlowApprove extends Vue {
  @Prop({ required: true }) servicepointId!: number;
  @Prop({ required: false }) userApprovals?: IUserServicepointApproval[];
  @Prop({ required: false }) countryId?: number;
  public collapsed = true;
  public showAddModal = false;
  public usersApprovalsLocal: IUserServicepointApproval[] = [];

  async mounted(): Promise<void> {
    this.initializeLocalUsers();
  }

  @Watch("userApprovals", { deep: true })
  onUserApprovalsChange(): void {
    this.initializeLocalUsers();
  }

  private initializeLocalUsers(): void {
    this.usersApprovalsLocal = this.userApprovals ? [...this.userApprovals] : [];
  }

  handleAddUsers(user: IUserServicepointApproval): void {
    const isDuplicate = this.usersApprovalsLocal.find(
      (existingUser) => existingUser.id === user.id
    );

    if (!isDuplicate) {
      this.usersApprovalsLocal.push(user);
      this.$emit("add-user", user);
    }
  }

  removeApproveUser(index: number): void {
    if (index >= 0 && index < this.usersApprovalsLocal.length) {
      const removedUser = this.usersApprovalsLocal.splice(index, 1)[0];
      this.$emit("remove-user", removedUser);
    }
  }

  openNewServicepointOnFlowApproveModal(): void {
    this.showAddModal = true;
    this.$nextTick(() => {
      this.$bvModal.show("addUserOnFlowApproveModal");
    });
  }

  handleModalClose(): void {
    this.$bvModal.hide("addUserOnFlowApproveModal");
    setTimeout(() => {
      this.showAddModal = false;
    }, 500);
  }

  get excludedUserIds(): number[] {
    return this.usersApprovalsLocal
      .map((user) => user.id)
      .filter((id): id is number => id !== undefined);
  }

  get fields(): BvTableFieldArray {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-first align-middle py-0",
      },
      {
        key: "username",
        label: i18n.t("column.username") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "name",
        label: i18n.t("column.name") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "lastName",
        label: i18n.t("column.lastname") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "email",
        label: i18n.t("column.email") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header py-0",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }
}
